import { createFileRoute } from "@tanstack/react-router";
import { ForbiddenPage } from "@/components/error-pages/forbidden-page";

// Standalone 403 route outside auth gate — auth guard can redirect here
// without triggering another redirect loop.
export const Route = createFileRoute("/403")({
  component: ForbiddenPage,
});
